import React from 'react';
import Grid from '@mui/material/Grid';
import { formatLastMeetingDuration, LAST_MEETING_COLOR_BAR_PAIRS } from '../utils';
import ColoredProgress from '../ClientShortFall/ColoredProgress/ColoredProgress';
import './LastMeetingHint.scss';
import Typography from '@mui/material/Typography';

export default class LastMeetingHint extends React.PureComponent {
  render() {
    const { intl, lastMeetingDuration } = this.props;
    const MthIntl = intl.formatMessage({ id: 'Mth' });
    return (
      <div>
        <Typography
          sx={{
            marginBottom: '16px'
          }}
        >
          {intl.formatMessage({ id: 'show-passed-time' })}
        </Typography>
        <Grid container sx={{ flexDirection: 'column', alignItems: 'center' }}>
          {LAST_MEETING_COLOR_BAR_PAIRS.map((pair, index) => (
            <Grid className="last-meeting-hint-row" key={index}>
              <ColoredProgress color={pair.color} percentage={pair.width} maxWidth="80px" />
              <span>
                {`${
                  pair.lastMeetingDurationMonths.largerThan
                    ? `${pair.lastMeetingDurationMonths.largerThan}${MthIntl} < `
                    : ''
                }${intl.formatMessage({ id: 'Day' })}${
                  pair.lastMeetingDurationMonths.lessThan
                    ? ` < ${pair.lastMeetingDurationMonths.lessThan}${MthIntl}`
                    : ''
                }`}
              </span>
            </Grid>
          ))}
        </Grid>
        <Grid
          container
          style={{ marginTop: 10 }}
          sx={{
            alignItems: 'center'
          }}
        >
          <Grid>
            <Typography>{intl.formatMessage({ id: 'client-long-time-no-see' })}</Typography>
          </Grid>
          <Grid>
            <Typography color="primary">{formatLastMeetingDuration(intl, lastMeetingDuration)}</Typography>
          </Grid>
        </Grid>
      </div>
    );
  }
}
